// extracted by mini-css-extract-plugin
export default {"cls1":"VeloDivider_cls1__ejlY-","cls2":"VeloDivider_cls2__PJljs VeloDivider_cls1__ejlY-","padded":"VeloDivider_padded__Nygo0","vertical":"VeloDivider_vertical__7AzYf"};